__webpack_require__.p = "https://assets.ntmg.com/_next/";